import { configureStore } from '@reduxjs/toolkit';

import { getAccountsThunk, getCreateAccountsSlice } from 'GeminiViewerComponent/features/accounts/accountsSlice';
import actionModalReducer from 'GeminiViewerComponent/features/common/actionModalSlice';
import contentReducer from 'features/content/contentSlice';
import assetManagerReducer from 'features/assets/assetManagerSlice';
import zonesTableReducer from 'features/zones/zonesTableSlice';
import itemsTableReducer from 'features/items/itemsTableSlice';
import picklistsReducer from 'features/picklists/pickListsSlice';
import proceduresReducer from 'features/procedures/proceduresSlice';
import audiencesReducer from 'features/audiences/audiencesSlice';
import editPanelReducer from 'features/common/editPanelSlice';
import formPanelReducer from 'features/common/formSlice';
import editZoneReducer from 'features/common/editZoneSlice';
import editAssetReducer from 'features/assets/editAssetSlice';
import loadZoneReducer from 'shared/loadZoneSlice';
import editItemReducer from 'features/common/editItemSlice';
import groupsReducer from 'features/groups/groupsSlice';
import categoryReducer from 'features/category/categorySlice';
import hotspotsReducer from 'shared/hotspotsSlice';
import linksReducer from 'GeminiViewerComponent/features/links/linksSlice';
import assetsReducer from 'features/assets/assetsTableSlice';
import assetExportReducer from 'features/assets/assetExportSlice';
import locationReducer from 'features/tools/locationSlice';
import toolsCategoryReducer from 'features/tools/toolsCategorySlice';
import toolsReducer from 'features/tools/toolSlice';
import rulesReducer from 'features/rules/rulesSlice';
import partGroupReducer from 'features/parts/partGroupSlice';
import partCategoryReducer from 'features/parts/partCategorySlice';
import partsReducer from 'features/parts/partSlice';
import visibilityReducer from 'features/globals/visibilitySlice';
import videoImportSliceReducer from 'scenes/VideoImporter/videoImportSlice';
import tagsSliceReducer from 'features/tags/tagsSlice';
import loadContentPanelReducer from 'shared/loadContentPanelSlice';
import validationTypesReducer from 'features/validationTypes/validationTypesSlice';
import validationRawTypesReducer from 'features/validationRawTypes/validationRawTypesSlice';
import configFieldsReducer from 'features/configFields/configFieldsSlice';
import configValuesReducer from 'features/configValues/configValuesSlice';
import clientsReducer from 'features/clients/clientsSlice';
import snippetsReducer from 'features/snippets/snippetsSlice';
import jobsReducer from 'features/jobs/jobsSlice';

import configReducer from 'GeminiViewerComponent/features/config/configSlice';
import loadingProgressReducer from 'GeminiViewerComponent/features/globals/loadingProgressSlice';
import viewerVisibilityReducer from 'GeminiViewerComponent/features/globals/visibilitySlice';
import flyerReducer from 'GeminiViewerComponent/features/globals/flyerSlice';
import viewerStatusReducer from 'GeminiViewerComponent/features/globals/viewerStatusSlice';
import assetReducer from 'GeminiViewerComponent/features/asset/assetSlice';
import xapiReducer from 'GeminiViewerComponent/features/xAPI/xapiSlice';
import zonePreviewReducer from 'GeminiViewerComponent/features/zonePreview/zonePreviewSlice';
import themeSliceReducer from 'GeminiViewerComponent/features/globals/themeSlice';
import mediaSliceReducer from 'GeminiViewerComponent/features/globals/mediaSlice';
import procedureSliceReducer from 'GeminiViewerComponent/components/Procedure/features/procedureSlice';
import checklistDataReducer from 'GeminiViewerComponent/components/Procedure/features/checklistDataSlice';
import contentPanelItemReducer from 'GeminiViewerComponent/features/contentPanel/contentPanelItemSlice';
import procedureSessionSliceReducer from 'GeminiViewerComponent/features/procedureSession/procedureSessionSlice';
import inspectionReducer from 'GeminiViewerComponent/features/inspection/inspectionSlice';
import companionAppsReducer from 'GeminiViewerComponent/features/companionApps/companionAppsSlice';
import chapterSliceReducer from 'GeminiViewerComponent/features/globals/chapterSlice';
import newsFlashReducer from 'GeminiViewerComponent/features/newsFlash/newsFlashSlice';

import { config } from 'gemini-config';

export const accountsThunk = getAccountsThunk({ config: config });
export const accountsSlice = getCreateAccountsSlice({
    accountsThunk: accountsThunk,
});

export const persistor = {}; // dummy object to match viewer

export default configureStore({
    reducer: {
        accounts: accountsSlice.slice.reducer,
        config: configReducer,
        clients: clientsReducer,
        assetManager: assetManagerReducer,
        zonesTable: zonesTableReducer,
        itemsTable: itemsTableReducer,
        picklists: picklistsReducer,
        procedures: proceduresReducer,
        actionModal: actionModalReducer,
        content: contentReducer,
        audiences: audiencesReducer,
        editPanel: editPanelReducer,
        forms: formPanelReducer,
        editZone: editZoneReducer,
        editAsset: editAssetReducer,
        loadZone: loadZoneReducer,
        editItem: editItemReducer,
        groups: groupsReducer,
        category: categoryReducer,
        hotspots: hotspotsReducer,
        links: linksReducer,
        loadingProgress: loadingProgressReducer,
        assets: assetsReducer,
        rules: rulesReducer,
        visibility: visibilityReducer,
        viewerVisibility: viewerVisibilityReducer,
        flyer: flyerReducer,
        viewerStatus: viewerStatusReducer,
        asset: assetReducer,
        xAPI: xapiReducer,
        zonePreview: zonePreviewReducer,
        videoImport: videoImportSliceReducer,
        tags: tagsSliceReducer,
        theme: themeSliceReducer,
        procedure: procedureSliceReducer,
        checklistData: checklistDataReducer,
        loadContentPanel: loadContentPanelReducer,
        contentPanelItem: contentPanelItemReducer,
        validationTypes: validationTypesReducer,
        validationRawTypes: validationRawTypesReducer,
        configFields: configFieldsReducer,
        configValues: configValuesReducer,
        assetExport: assetExportReducer,
        location: locationReducer,
        toolsCategory: toolsCategoryReducer,
        tools: toolsReducer,
        media: mediaSliceReducer,
        partGroup: partGroupReducer,
        partCategory: partCategoryReducer,
        parts: partsReducer,
        inspection: inspectionReducer,
        procedureSession: procedureSessionSliceReducer,
        companionApps: companionAppsReducer,
        snippets: snippetsReducer,
        chapter: chapterSliceReducer,
        newsFlash: newsFlashReducer,
        jobs: jobsReducer,
    },
});
